import type { Rule } from 'antd/es/form';

import { hasNonAsciiChar } from 'app/utils/email';

export const requiredRule: Rule = {
  required: true,
  message: 'This field is required',
};

export const emailAsciiRule: Rule = {
  validator: (_, value?: string) =>
    hasNonAsciiChar(value)
      ? Promise.reject(
          new Error('Email must not contain accented or special characters')
        )
      : Promise.resolve(),
};

export const maxCharactersRule = (maxCharacters: number): Rule => {
  return {
    max: maxCharacters,
    message: `Max ${maxCharacters} characters`,
  };
};
